import React, { useState, useEffect, useMemo } from "react";
import LoaderStyleOne from "../../../components/LoaderStyleOne";
import MUIDataTable from "mui-datatables";
import {
  Box,
  Grid,
  Link,
  Select,
  Typography,
  TextField,
  IconButton,
  TableCell,
  Modal,
  Button,
  Autocomplete,
  Checkbox,
  Chip,
} from "@mui/material";
import { getData, postData } from "../../../ServerRequest";
import SearchIcon from "@mui/icons-material/Search";
import LandscapeIcon from "@mui/icons-material/Landscape";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
//import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
//import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";

export default function CollectionItems() {
  const searchParams = new URLSearchParams(window.location.search);
  const collectionId = searchParams.get("collection_id");
  const [loading, setLoading] = useState(true);
  const [tagsData, setTagsData] = useState([]);
  const [collectionData, setCollectionData] = useState([]);
  const [mappingData, setMappingData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [initialCollectionData, setInitialCollectionData] = useState(null);
  const [collectionCombData, setCollectionCombData] = useState([]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    // Fetch available tags from API and setTagsData
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Utility to generate a slug from tags (for backend mapping)
  const generateSlug = (tags) => {
    return tags
      .join(",")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, ",")
      .replace(/^-+|-+$/g, "");
  };

  // The collection URL should only use the collection ID
  const computedCollectionUrl = collectionId
    ? `https://acc.bizallen.com/products?collection_id=${collectionId}`
    : "";

  const handleAddTags = async () => {
    // Merge selected tags with existing tags, avoiding duplicates
    const existingTags = Array.isArray(collectionData.tag)
      ? collectionData.tag
      : collectionData.tag
      ? collectionData.tag
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean)
      : [];
    const newTagNames = selectedTags.map((tag) => tag.product_tag);
    // Merge and deduplicate
    const mergedTags = Array.from(new Set([...existingTags, ...newTagNames]));
    setCollectionData((prev) => ({ ...prev, tag: mergedTags }));
    setIsModalOpen(false);
    // Update backend mapping with new slug
    const slug = generateSlug(mergedTags);
    await postData("/api/product/product-collection", {
      collection_id: collectionId,
      slug,
    });
  };

  // Remove tag handler (update tags array and backend mapping)
  const handleRemoveTag = async (tagToRemove) => {
    const updatedTags = collectionData.tag.filter((t) => t !== tagToRemove);
    setCollectionData((prev) => ({ ...prev, tag: updatedTags }));
    // Update backend mapping with new slug
    const slug = generateSlug(updatedTags);
    await postData("/api/product/product-collection", {
      collection_id: collectionId,
      slug,
    });
  };

  const handleSaveEdit = async () => {
    try {
      // Convert tag names to tag IDs before saving
      let tagIds = collectionData.tag;
      if (Array.isArray(tagIds)) {
        tagIds = tagIds.map((tagName) => {
          const found = tagsData.find((t) => t.product_tag === tagName);
          return found ? found.id : tagName; // fallback to tagName if not found
        });
      } else if (typeof tagIds === "string") {
        tagIds = tagIds
          .split(",")
          .map((t) => {
            const trimmed = t.trim();
            const found = tagsData.find((tag) => tag.product_tag === trimmed);
            return found ? found.id : trimmed;
          })
          .filter(Boolean);
      } else {
        tagIds = [];
      }

      const reqData = {
        'collection_id': collectionData.id ? collectionData.id : "",
        'collection_name': collectionData.collection ? collectionData.collection : "",
        'promotional_name': collectionData.promotional_name ? collectionData.promotional_name : "",
        'marketing_keyword': collectionData.marketing_keyword ? collectionData.marketing_keyword : "",
        'search_collection': tagIds,
        'nested_collection': collectionData.nested_collection ? collectionData.nested_collection : "",
        'collection_url': computedCollectionUrl,
        'minimum_quantity': collectionData.minimum_quantity || "",
      };
      // Call your API to save changes
      const resData = await postData(
        "/api/product/product-collection",
        reqData
      );
      if (resData["data"]["code"] === "200") {
        alert("Collection updated successfully!");
        // Fetch latest data to update UI
        fetchCollectionData();
      } else {
        alert("Failed to update collection.");
      }
    } catch (error) {
      alert("Error saving collection.");
      console.error(error);
    }
  };

  // Refactor data fetching logic so it can be called after save
  const fetchCollectionData = async () => {
    try {
      let masterRes = await getData("/api/product/acc_tag_master");
      let master_data = masterRes["data"]["live_tags"];
      if (master_data) {
        const formattedData = master_data.map((tag) => ({
          id: tag.id,
          product_tag: tag.product_tag,
        }));
        setTagsData(formattedData);
      }
      if (collectionId) {
        var collectionReqData = await getData(
          `/api/product/product-collection?collection_data_id=${collectionId}`
        );
        var collectionCombinationReqData = await getData(
          `/api/product/get-product-collection-combinations?collection_id=${collectionId}`
        );
        console.log("Collection Combination Data:", collectionCombinationReqData);
        console.log("collectionId:", collectionId);
        console.log("collectionReqData:", collectionReqData);
        setCollectionCombData(collectionCombinationReqData["data"]["combinations"] || []);
        const tagMap = master_data.reduce((acc, tag) => {
          acc[tag.id] = tag.product_tag;
          return acc;
        }, {});
        let singleCollection = collectionReqData["data"]["collection_data"];
        console.log("singleCollection before tag mapping:", singleCollection);
        if (singleCollection && singleCollection.tag) {
          singleCollection = {
            ...singleCollection,
            tag: singleCollection.tag.map((tagId) => tagMap[tagId] || tagId),
          };
        }
        console.log("singleCollection after tag mapping:", singleCollection);
        setCollectionData(singleCollection);
        setInitialCollectionData(singleCollection);
        const itemsWithCollectionId = collectionCombinationReqData["data"]["products"].map((item) => ({
          ...item,
          collection_id: collectionId,
        }));
        setMappingData(itemsWithCollectionId);
      } else {
        var reqData = await getData("/api/product/product-collection");
      }
      let collection_data = reqData && reqData["data"]["collection_data"];
      console.log("collection_data from reqData:", collection_data);
      if (collection_data) {
        const tagMap = master_data.reduce((acc, tag) => {
          acc[tag.id] = tag.product_tag;
          return acc;
        }, {});
        const mapTags = (collections) =>
          collections.map((collection) => ({
            ...collection,
            tag: collection.tag?.map((tagId) => tagMap[tagId] || tagId) || [],
          }));
        setCollectionData(mapTags(collection_data));
        setInitialCollectionData(mapTags(collection_data));
      }
      if (!collectionId && collection_data) {
        const selectedCollection = collection_data?.find(
          (collection) => collection.id === parseInt(collectionId)
        );
        console.log("selectedCollection:", selectedCollection);
        if (selectedCollection) {
          setCollectionData(selectedCollection);
          setInitialCollectionData(selectedCollection);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollectionData();
    // eslint-disable-next-line
  }, [collectionId]);

  // Check if any editable field has changed
  const isCollectionChanged = () => {
    if (!initialCollectionData) return false;
    const fields = [
      "collection",
      "promotional_name",
      "marketing_keyword",
      "tag",
      "nested_collection",
      "minimum_quantity", // <-- add this field
    ];
    return fields.some((field) => {
      const initial = initialCollectionData[field] || "";
      const current = collectionData[field] || "";
      if (Array.isArray(initial) || Array.isArray(current)) {
        return JSON.stringify(initial) !== JSON.stringify(current);
      }
      return initial !== current;
    });
  };

  const renderSortIcon = (columnMeta, sortOrder) => {
    if (sortOrder && sortOrder.index === columnMeta.index) {
      // Highlighted icon for sorted column
      return sortOrder.direction === "asc" ? (
        <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#333" }} />
      ) : (
        <ArrowDownwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#333" }} />
      );
    }
    // Not sorted: show faded up arrow
    return <ArrowUpwardIcon style={{ fontSize: 16, marginLeft: 4, color: "#ccc" }} />;
  };

  const columns = [
    {
      name: "ps_product_productimg",
      label: "Image",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontWeight: "bold",
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          // Extract the first image from the comma-separated string
          const firstImage = value ? value.split(",")[0].trim() : null;
          const baseURL =
            "https://www.ambikacc.com/product-profile-temp/medium-";

          return (
            <div
              style={{
                width: 80,
                height: 53,
                backgroundColor: "#F3F4F6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "0px",
                border: "1px solid #F3F4F6",
                overflow: "hidden",
                textAlign: "center",
                margin: "auto",
              }}
            >
              {firstImage ? (
                <img
                  src={`${baseURL}${firstImage}`} // Construct the full image URL if needed
                  alt="img"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <LandscapeIcon style={{ color: "#BCC1CA", fontSize: 30 }} />
              )}
            </div>
          );
        },
      },
    },

    {
      name: "ps_product_productcode",
      label: "Product Code",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 600 },
        }),
      },
    },

    {
      name: "ps_product_prodname",
      label: "Product Name",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 700,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 600 },
        }),
      },
    },

    {
      name: "ps_product_netqty",
      label: "Stock in Mtr",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    },

    {
      name: "ps_product_cat",
      label: "Fabric Category",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 700,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {renderSortIcon(columnMeta, sortOrder)}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center", fontWeight: 500 },
        }),
      },
    },

    // {
    //   name: "ps_product_tags3",
    //   label: "Tags",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
    //       <TableCell
    //         key={columnMeta.index}
    //         style={{
    //           fontFamily: "inter",
    //           fontWeight: 600,
    //           backgroundColor: "#FAFAFB",
    //           textAlign: "center",
    //         }}
    //       >
    //         {columnMeta.label}
    //       </TableCell>
    //     ),
    //     setCellProps: () => ({
    //       style: { textAlign: "center" },
    //     }),
    //     customBodyRender: (value, tableMeta) => {
    //       if (Array.isArray(value)) {
    //         return (
    //           <div
    //             style={{
    //               display: "flex",
    //               flexWrap: "wrap",
    //               gap: "5px",
    //               justifyContent: "center",
    //             }}
    //           >
    //             {value.map((tag, index) => (
    //               <div
    //                 key={index}
    //                 style={{
    //                   padding: "5px 10px",
    //                   backgroundColor: "#F3F4F6",
    //                   border: "1px solid #BCC1CA",
    //                   borderRadius: "15px",
    //                   fontSize: "12px",
    //                   color: "#323842",
    //                   textAlign: "center",
    //                   flex: "0 0 calc(25% - 5px)",
    //                   boxSizing: "border-box",
    //                 }}
    //               >
    //                 {tag}
    //               </div>
    //             ))}
    //           </div>
    //         );
    //       } else if (typeof value === "string") {
    //         const tags = value.split(",").map((tag) => tag.trim());
    //         return (
    //           <div
    //             style={{
    //               display: "flex",
    //               flexWrap: "wrap",
    //               gap: "5px",
    //               justifyContent: "center",
    //             }}
    //           >
    //             {tags.map((tag, index) => (
    //               <div
    //                 key={index}
    //                 style={{
    //                   padding: "5px 10px",
    //                   backgroundColor: "#F3F4F6",
    //                   borderRadius: "15px",
    //                   fontSize: "12px",
    //                   color: "#323842",
    //                   textAlign: "center",
    //                   flex: "0 0 calc(25% - 5px)", // Ensure 4 tags per row
    //                   boxSizing: "border-box",
    //                 }}
    //               >
    //                 {tag}
    //               </div>
    //             ))}
    //           </div>
    //         );
    //       }
    //       return value;
    //     },
    //   },
    // },

    /* {
      name: "ps_product_status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
              cursor: "pointer",
            }}
            onClick={() => handleToggleColumn(columnMeta.index)}
          >
            {columnMeta.label}
            {sortOrder && sortOrder.direction === "asc" && <span> .</span>}
            {sortOrder && sortOrder.direction === "desc" && <span> .</span>}
          </TableCell>
        ),
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
      },
    }, */

    {
      name: "edit",
      label: "Action",
      options: {
        sort: false,
        customHeadRender: (columnMeta) => (
          <TableCell
            key={columnMeta.index}
            style={{
              fontFamily: "inter",
              fontWeight: 600,
              backgroundColor: "#FAFAFB",
              textAlign: "center",
            }}
          >
            {columnMeta.label}
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Link
              style={{
                color: "black",
                fontWeight: "bold",
                textDecoration: "none",
              }}
              href={`/admin/products/productDetail/productDetail?product_id=${tableMeta.rowData[1]}`}
            >
              <IconButton>
                <EditOutlinedIcon
                  style={{ color: "black", width: "20px", height: "20px" }}
                />
              </IconButton>
            </Link>
            {/* <IconButton
            //onClick={() => handleArchiveCollection(tableMeta.rowIndex)}
            >
              <ArchiveOutlinedIcon
                style={{ color: "black", width: "20px", height: "20px" }}
              />
            </IconButton>
            <IconButton
            //onClick={() => handleDeleteCollection(tableMeta.rowIndex)}
            >
              <DeleteOutlinedIcon
                style={{ color: "black", width: "20px", height: "20px" }}
              />
            </IconButton> */}
          </div>
        ),
      },
    },
  ];

  const options = {
    elevation: 0,
    filterType: "checkbox",
    responsive: "standard",
    tableBodyHeight: "calc(100vh - 64px - 48px)",
    tableBodyMaxHeight: "calc(100vh - 64px - 48px)",
    print: false, // Disable print
    download: false, // Disable download
    columns: false, // Disable column visibility
    viewColumns: false, // Disable view columns
    filter: false,
    search: false,
    textLabels: {
      body: {
        noMatch: loading ? "Loading..." : "Sorry, no matching records found",
      },
    },
    selectableRows: "none", // Disable row selection
  };

  // Filtered data based on searchQuery
  const filteredData = useMemo(() => {
    if (!Array.isArray(mappingData)) return [];
    if (!searchQuery) return mappingData;

    return mappingData
      .filter((row) => row) // Exclude null or undefined rows
      .filter((row) =>
        Object.values(row || {}).some((value) =>
          typeof value === "object"
            ? Object.values(value || {}).some((subValue) =>
                subValue
                  ?.toString()
                  .toLowerCase()
                  .includes(searchQuery.toLowerCase())
              )
            : value
                ?.toString()
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
      );
  }, [mappingData, searchQuery]);

  // Add handlers for editable fields
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setCollectionData((prev) => ({ ...prev, [id]: value }));
  };

  // Guard: show loading or error if collectionData is not ready
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
        <LoaderStyleOne />
      </Box>
    );
  }
  /* if (!collectionData || Array.isArray(collectionData)) {
    return <div style={{ textAlign: "center", color: "red" }}>No Products in collection.</div>;
  } */
  if (!collectionData || Array.isArray(collectionData)) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "400px",
          background: "#f8f9fa",
          borderRadius: "0px",
          color: "#565E6D",
          fontSize: "1.2rem",
          fontWeight: "500",
          margin: "32px auto",
          maxWidth: "95%",
        }}
      >
        No Products in collection
      </div>
    );
  }

  return (
    <Box sx={{ width: "95%", paddingLeft: 3, mb: 5 }}>
      <Grid container sx={{ flex: 1, height: "100%" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
         { /* View collection Section */}
                <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 0,
                  mb: 2,
                }}
                >
                <Typography
                  variant="body1"
                  sx={{ font: "Inter", fontWeight: 700, fontSize: 17 }}
                >
                  Items in Collection
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Button
                  variant="contained"
                  onClick={() => {
                    window.location.href = "/admin/products/collectionMaster/editCollectionItems?collection_id="+collectionId;
                  }}
                  sx={{
                    height: "35px",
                    borderRadius: "0px",
                    backgroundColor: "#565E6D",
                    color: "#F3F4F6",
                    textTransform: "none",
                    "&:hover": {
                    backgroundColor: "#E5E7EB",
                    color: "black",
                    },
                  }}
                  >
                  Edit Collection
                  </Button>
                </Box>
                </Box>

                {/* Add Items Modal */}
          <Modal open={isModalOpen} onClose={handleCloseModal}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 400,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: 0,
                border: "1px solid #bcc1ca",
                fontFamily: "Inter",
              }}
            >
              <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                Add Items to Collection
              </Typography>
              <Autocomplete
                multiple
                options={tagsData}
                getOptionLabel={(option) => option.product_tag}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={{
                      fontSize: "0.875rem",
                      padding: "2px 6px",
                      border: "1px solid #DEE1E6",
                      color: "#565E6D",
                      backgroundColor: selected ? "#f5f5f5" : "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.product_tag}
                  </li>
                )}
                renderTags={(value) =>
                  value.map((option) => option.product_tag).join(", ")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder={
                      selectedTags.length === 0 ? "Type to search tags..." : ""
                    }
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "0px",
                      },
                    }}
                  />
                )}
                sx={{ mb: 2 }}
                inputValue={tags}
                onInputChange={(event, newValue) => setTags(newValue)} // Update input value
                onChange={(event, newValue) => setSelectedTags(newValue)} // Update selected tags
                isOptionEqualToValue={(option, value) => option.id === value.id} // Compare by id
                filterOptions={(options, state) => {
                  const inputValue = state.inputValue.toLowerCase();
                  const filteredOptions = options.filter(
                    (option) =>
                      option.product_tag.toLowerCase().includes(inputValue) &&
                      !selectedTags.some(
                        (selected) => selected.id === option.id
                      )
                  );
                  const selectedOptions = selectedTags.filter((selected) =>
                    selected.product_tag.toLowerCase().includes(inputValue)
                  );
                  return [...selectedOptions, ...filteredOptions];
                }}
                filterSelectedOptions
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="contained"
                  onClick={handleAddTags}
                  sx={{
                    mr: 1,
                    borderRadius: "0px",
                    backgroundColor: "#565E6D",
                    color: "white",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#f3f4f6",
                      border: "1px solid #bcc1ca",
                      color: "black",
                    },
                  }}
                >
                  Add
                </Button>
                <Button
                  onClick={handleCloseModal}
                  sx={{
                    mr: 0,
                    borderRadius: "0px",
                    backgroundColor: "white",
                    border: "1px solid #bcc1ca",
                    color: "black",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#f3f4f6",
                    },
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          </Modal>

          <Grid
            container
            sx={{
              backgroundColor: "#F8F9FA",
              border: "1px solid #F3F4F6",
              padding: 2,
              borderRadius: "0px",
              mb: 2,
              mt: 4,
              flexWrap: "wrap", // Ensure grid items wrap on smaller screens
            }}
          >
            <Grid container spacing={2}>
              {/* First Column */}
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column", // Stack label and input vertically
                    alignItems: "flex-start",
                    marginBottom: "16px",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Collection Name :
                  </Typography>
                  <textarea
                    id="collection"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      minHeight: "35px",
                      maxHeight: "120px",
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 700,
                      fontSize: "14px",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      resize: "vertical",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"
                    }}
                    value={collectionData.collection || ""}
                    readOnly
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Promotional Name :
                  </Typography>
                  <textarea
                    id="promotional_name"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      minHeight: "35px",
                      maxHeight: "120px",
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "14px",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      resize: "vertical",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"
                    }}
                    value={collectionData.promotional_name || ""}
                    readOnly
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Marketing keywords :
                  </Typography>
                  <textarea
                    id="marketing_keyword"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      minHeight: "35px",
                      maxHeight: "120px",
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "14px",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      resize: "vertical",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"
                    }}
                    value={collectionData.marketing_keyword || ""}
                    readOnly
                  />
                </Box>
              </Grid>

              {/* Second Column */}
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    URL :
                  </Typography>
                  <textarea
                    id="collectionStatus"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      minHeight: "35px",
                      maxHeight: "120px",
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "14px",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      resize: "vertical",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"

                    }}
                    value={collectionData.collection_url || ""}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Product Count :
                  </Typography>
                  <input
                    id="productCount"
                    type="text"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "14px",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"
                    }}
                    value={mappingData.length || ""}
                    readOnly
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Status :
                  </Typography>
                  <input
                    id="status"
                    type="text"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "14px",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"
                    }}
                    value={collectionData.collection_status || ""}
                    readOnly
                  />
                </Box>
              </Grid>

              {/* Third Column */}
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Tags :
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      minHeight: 40,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    {Array.isArray(collectionData.tag) &&
                    collectionData.tag.length > 0 ? (
                      collectionData.tag.map((tag, idx) => (
                        <Chip
                          key={tag + idx}
                          label={tag}
                          sx={{
                            borderRadius: "16px",
                            background: "#565E6D",
                            color: "white",
                          }}
                        />
                      ))
                    ) : (
                      <Typography variant="body2" sx={{ color: "#BCC1CA" }}>
                        No tags
                      </Typography>
                    )}
                  </Box>
                </Box>
                {/* <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Nested Collection :
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      minHeight: 40,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    {Array.isArray(collectionData.nested_collection) &&
                    collectionData.nested_collection.length > 0 ? (
                      collectionData.nested_collection.map((item, idx) => (
                        <Chip
                          key={item + idx}
                          label={item}
                          onDelete={() => {
                            setCollectionData((prev) => ({
                              ...prev,
                              nested_collection: prev.nested_collection.filter(
                                (t) => t !== item
                              ),
                            }));
                          }}
                          sx={{
                            borderRadius: "16px",
                            background: "#565E6D",
                            color: "white",
                            fontWeight: 500,
                            "& .MuiChip-deleteIcon": {
                              color: "white",
                            },
                          }}
                        />
                      ))
                    ) : (
                      <Typography variant="body2" sx={{ color: "#BCC1CA" }}>
                        No nested collections
                      </Typography>
                    )}
                  </Box>
                </Box> */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginBottom: "16px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#424956",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      fontSize: "14px",
                      marginBottom: "4px",
                    }}
                  >
                    Min Quantity(Mtr) :
                  </Typography>
                  <textarea
                    id="minimum_quantity"
                    style={{
                      width: "100%",
                      minWidth: 0,
                      minHeight: "35px",
                      maxHeight: "120px",
                      padding: "4px",
                      border: "1px solid #F8F9FA",
                      borderRadius: "0px",
                      backgroundColor: "#F8F9FA",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "14px",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      resize: "vertical",
                      boxSizing: "border-box",
                      outline: "none",
                      boxShadow: "none",
                      transition: "none",
                      pointerEvents: "none"
                    }}
                    value={collectionData.minimum_quantity || ""}
                    readOnly
                  />
                </Box>
                {/* End of all label/input fields in the third column */}
              </Grid>
            </Grid>
            {/* Save Button in a separate centered div below the fields */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mt: 1,
                mb: 0.5,
              }}
            >

            </Box>
          </Grid>

          {/* Collection combination Table */}
          <Box
            sx={{
              border: "1px solid #F4F3F6",
              '& div[class*="MUIDataTableToolbar"]': { display: "none" },
              mb: 2,
              mt: 2,
              background: "#fff",
              borderRadius: "0px",
              overflow: "auto",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 700,
                fontSize: 16,
                p: 2,
                pb: 0,
                color: "#424956",
              }}
            >
              Collection Combinations
            </Typography>
            <Box sx={{ p: 2, pt: 1 }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8F9FA" }}>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "8px",
                        fontWeight: 600,
                        borderBottom: "1px solid #F3F4F6",
                        fontFamily: "Inter",
                        fontSize: "14px",
                      }}
                    >
                      Combination
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "8px",
                        fontWeight: 600,
                        borderBottom: "1px solid #F3F4F6",
                        fontFamily: "Inter",
                        fontSize: "14px",
                      }}
                    >
                      Product Count
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(collectionCombData) && collectionCombData.length > 0 ? (
                    collectionCombData.map((comb) => (
                      <tr key={comb.id}>
                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #F3F4F6",
                            fontFamily: "Inter",
                            fontSize: "14px",
                          }}
                        >
                          {comb.combination}
                        </td>
                        <td
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #F3F4F6",
                            fontFamily: "Inter",
                            fontSize: "14px",
                          }}
                        >
                          {comb.product_count}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={2} style={{ padding: "8px", color: "#BCC1CA" }}>
                        No combinations found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Box>
          </Box>


          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            {/* Search Box */}
            {/* <TextField
              sx={{
                mr: 2,
                "& .MuiOutlinedInput-root": {
                  height: "35px",
                  width: "390px",
                  borderRadius: "0px",
                },
              }}
              size="small"
              variant="outlined"
              placeholder="Search by product name, tag, product code"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <IconButton
                    position="start"
                    sx={{ ml: "-10px", mr: 1, color: "black" }}
                  >
                    <SearchIcon />
                  </IconButton>
                ),
              }}
            /> */}
           
          </Box>


          <Box
            sx={{
              border: "1px solid #F4F3F6",
              '& div[class*="MUIDataTableToolbar"]': { display: "none" },
            }}
          >
            <MUIDataTable
              title={""}
              data={loading ? [] : filteredData}
              columns={columns}
              options={{ ...options, elevation: 0 }}
            />
          </Box>
        </Box>
      </Grid>
    </Box>
  );
}
